import SegmentedControl, { SegmentedControlOption } from "ds/components/SegmentedControl";
import Icon from "ds/components/Icon";
import { BarChart, LineChart } from "components/icons/generated";

import useDoraChartType, { DoraChartType } from "../useChartType";

const OPTIONS: SegmentedControlOption<DoraChartType>[] = [
  {
    value: "line",
    label: (
      <>
        <Icon src={LineChart} noShrink />
        Line
      </>
    ),
  },
  {
    value: "bar",
    label: (
      <>
        <Icon src={BarChart} noShrink />
        Bar
      </>
    ),
  },
];

type ChartTypeToggleProps = {
  storageKey: string;
};

const ChartTypeToggle = ({ storageKey }: ChartTypeToggleProps) => {
  const { chartType, onChange } = useDoraChartType(storageKey);

  return <SegmentedControl options={OPTIONS} value={chartType} onChange={onChange} size="small" />;
};

export default ChartTypeToggle;
